<template>
  <div
    :class="{ 'TheModal-Invisible': !visible }"
    class="TheModal"
    @keyup="keyMonitor"
  >
    <article 
      :class="{ 'TheModal-Inner--small': small }" 
      class="TheModal-Inner"
    >
      <header
        v-if="showTitle || allowClose"
        class="TheModal-Header"
      >
        <div 
          v-if="showTitle" 
          class="TheModal-TitleWrapper"
        >
          <h1 class="TheModal-Title">{{ title }}</h1>
        </div>

        <div 
          v-if="allowClose" 
          class="TheModal-CloseButtonWrapper"
        >
          <a
            class="TheModal-CloseButtonLink"
            href="#"
            title="Fechar"
            @click="clickToClose"
          >
            &times;
          </a>
        </div>
      </header>

      <section
        :class="{ 'TheModal-Content--small': small }"
        class="TheModal-Content"
      >
        <slot />
      </section>
    </article>
  </div>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .TheModal {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: $color-background-white;

    @media screen and (min-width: $tablet-breakpoint) {
      background-color: $color-background-transparent;
    }

    &-Inner {
      position: fixed;
      z-index: 9999;
      // background-color: $color-background-white;
      background-size: 10px 10px;
      background-image: repeating-linear-gradient(45deg, $background-pattern-gray 0, $background-pattern-gray 1px, $color-background-white 0, $color-background-white 50%);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      @media screen and (min-width: $tablet-breakpoint) {
        top: 50%;
        left: 50%;
        width: 80vw;
        border-radius: 10px;
        transform: translate(-50%, -50%);
        height: auto;
        max-height: 90vh;
        background-image: repeating-linear-gradient(45deg, $background-pattern-gray-transparent 0, $background-pattern-gray-transparent 0.5px, $color-background-white 0, $color-background-white 50%);
      }

      @media screen and (min-width: $desktop-breakpoint) {
        max-width: $desktop-breakpoint;
      }

      &--small {
        @media screen and (min-width: $tablet-breakpoint) {
          max-width: 500px;
        }
      }
    }

    &-Content {
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      //margin-bottom: 20px;
      scrollbar-color: $color-background-border rgba(0, 0, 0, 0);
      max-height: calc(100vh - 60px);

      @media screen and (min-width: $tablet-breakpoint) {
        max-height: 66vh;
      }

      @media screen and (min-width: $desktop-breakpoint) {
        max-width: $desktop-breakpoint;
      }

      &--small {
        @media screen and (min-width: $desktop-breakpoint) {
          max-width: 500px;
        }
      }
    }

    &-Invisible {
      display: none;
    }

    &-Header {
      display: flex;
      align-items: center;
      background-color: $background-dark-color;
      border-bottom: 1px solid $background-dark-border;
      color: $foreground-light-color;

      @media screen and (min-width: $tablet-breakpoint) {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }
    }

    &-TitleWrapper {
      flex: 1 1 auto;
    }

    &-Title {
      margin: 10px 20px;
      cursor: default;
      font-size: 24px;
    }

    &-CloseButtonWrapper {
      flex: 0 0 auto;
      justify-self: flex-end;
      margin-right: 10px;
    }

    &-CloseButtonLink {
      font-size: 36px;
      padding: 5px;
      color: $foreground-light-color;
    }

    &-CloseButtonLink:hover {
      text-decoration: none;
    }
  }
</style>

<script>
  import { OPEN_MODAL } from "@/store/actions.type";

  export default {

    props: {
      allowClose: {
        type: Boolean,
        default: true,
      },

      title: {
        type: String,
        default: "",
      },

      visible: {
        type: Boolean,
        default: false,
      },

      small: {
        type: Boolean,
        default: false,
      },
    },

    data: () => {
      return {
        keyListener: null,
      };
    },
    computed: {
      showTitle() {
        return this.title !== "";
      },
    },

    watch: {
      visible(value) {
        this.$store.dispatch(OPEN_MODAL, value);

        if (value) {
          document.body.classList.add("modal-opened");
          this.addKeyListener();
        } else {
          document.body.classList.remove("modal-opened");
          this.removeKeyListener();
        }
      },
    },

    beforeDestroy() {
      this.removeKeyListener();
    },

    methods: {
      clickToClose(event) {
        this.$emit("close");
        event.preventDefault();
      },

      keyMonitor(event) {
        if (event.key === "Escape" && this.allowClose) {
          this.$emit("close");
        }
      },

      addKeyListener() {
        if (this.keyListener !== null) {
          return;
        }

        this.keyListener = document.addEventListener("keyup", this.keyMonitor);
      },

      removeKeyListener() {
        if (this.keyListener !== null) {
          document.removeEventListener("keyup", this.keyMonitor);
          this.keyListener = null;
        }
      },
    },
  };
</script>
